require('./bootstrap');

import SignaturePad from 'signature_pad';

$(function () {
    $('[data-toggle="tooltip"]').tooltip();
    // $('.js-voted').tooltip('show')

    var $window = $(window),
        $body = $("body"),
        $modal = $(".modal"),
        scrollDistance = 0;

    $modal.on("show.bs.modal", function() {
        // Get the scroll distance at the time the modal was opened
        scrollDistance = $window.scrollTop();

        // Pull the top of the body up by that amount
        $body.css("top", scrollDistance * -1);
    });
    $modal.on("hidden.bs.modal", function() {
        // Remove the negative top value on the body
        $body.css("top", "");

        // Set the window's scroll position back to what it was before the modal was opened
        $window.scrollTop(scrollDistance);
    });
})

//Get the button
let backButton = document.getElementById("btn-back");

// When the user scrolls down 20px from the top of the document, show the button
window.onscroll = function () {
    scrollFunction();
};

function scrollFunction() {
    if (
        document.body.scrollTop > 20 ||
        document.documentElement.scrollTop > 20
    ) {
        if(backButton) {
            $(backButton).fadeOut();
        }
    } else {
        if(backButton) {
            $(backButton).fadeIn();
        }
    }
}
if(backButton) {
    backButton.addEventListener("click", back);
}

var wrapper = document.getElementById("signature-pad");
var clearButton = document.getElementById("signature-pad-clear");
var canvas = wrapper.querySelector("canvas");
var signaturePad = new SignaturePad(canvas, {
    // It's Necessary to use an opaque color when saving image as JPEG;
    // this option can be omitted if only saving as PNG or SVG
    backgroundColor: 'rgb(255, 255, 255)'
});

function resizeCanvas() {
    var ratio =  Math.max(window.devicePixelRatio || 1, 1);
    canvas.width = canvas.offsetWidth * ratio;
    canvas.height = canvas.offsetHeight * ratio;
    canvas.getContext("2d").scale(ratio, ratio);
    signaturePad.clear(); // otherwise isEmpty() might return incorrect value
}

window.addEventListener("resize", resizeCanvas);
resizeCanvas();

clearButton.addEventListener("click", function (event) {
    signaturePad.clear();
});


$('#registerForm').submit(function (e) {
    e.preventDefault();
    if (signaturePad.isEmpty()) {
        alert('Nu ai semnat');
        return false;
    }
    document.getElementById('signatureInput').value = canvas.toDataURL('image/png');

    let formData = $(this).serializeArray();
    $(".invalid-feedback").children("strong").text("");
    $("#registerForm input").removeClass("is-invalid");
    $.ajax({
        method: "POST",
        headers: {
            Accept: "application/json"
        },
        url: window.urlRegister,
        data: formData,
        success: () => {
            window.location.reload()
        },
        error: (response) => {
            if(response.status === 422) {
                let focused = false;
                let errors = response.responseJSON.errors;
                Object.keys(errors).forEach(function (key) {
                    $("#" + key + "Input").addClass("is-invalid");
                    $("#" + key + "Error").children("strong").text(errors[key][0]);
                    if(!focused){
                        $('.modal-body').animate({
                            scrollTop: 0
                        },400);
                        focused = true;
                    }
                });
            } else {
                window.location.reload();
            }
        }
    })
});

$( ".js-vote-option" ).click(function() {
    if (window.isLoggedIn) {
        let id = $(this).data('id');
        let title = $(this).data('title');
        let image = $(this).data('image');
        showVote(id, title, image);
    } else {
        showLogin();
    }
});
$( "#registerButton" ).click(function() {
    showRegister();
});

global.showCampaignInactive = function(){
    $('#inactiveCampaignModal').modal({
        show: true
    });
}
global.showLoginOrRegister = function(){
    $('#loginOrRegisterModal').modal({
        show: true
    });
}
global.showLogin = function(){
    $('#loginModal').modal({
        show: true
    });
}
global.showRegister = function() {
    $('#registerModal').modal({
        show: true,
    });
    setTimeout(()=>{
        resizeCanvas();
    },1000);
}

$( "#js-aftervote-button" ).click(function() {
    window.location.href = window.urlRanking;
});

$('#voteForm').submit(function (e) {
    e.preventDefault();

    let formData = $(this).serializeArray();

    $.ajax({
        method: "POST",
        headers: {
            Accept: "application/json"
        },
        url: $('#voteForm').attr('action'),
        data: formData,
        success: (response) => {
            console.log(response);
            if(response.data.prize){
                $('#voteModalTitle').html('Felicitari!');

                $('#voteCardBody').html(
                    `
                        ${response.message}
                        <h3>${response.data.prize.name}</h3>
                    `);
                if(response.data.prize.description!="") {
                    $('#voteCardBody').append(`<h4>${response.data.prize.description}</h4>`);
                }
                $('#voteModalVoteOptionImage').attr('src', response.data.prize.image);
            }else{
                $('#voteModalTitle').html('Felicitari!');
                $('#voteCardBody').html(response.message);

                $('#voteModalVoteOptionImage').remove();
            }
            $('#js-close-button').remove();
            $('#js-vote-button').remove();
            $('#js-aftervote-button').removeClass('d-none');
        },
        error: (response) => {
            console.log(response.responseJSON);
            $('#voteModalTitle').html('A intervenit o problema');
            $('#voteCardBody').html(response.responseJSON.message);
            $('#voteModalVoteOptionImage').remove();
            $('#js-close-button').remove();
            $('#js-vote-button').remove();
            $('#js-aftervote-button').removeClass('d-none');
        }
    })
});

global.showVote = function(id, title, image) {
    $('#voteOptionID').val(id);
    $('#voteModalVoteOption').html(title);
    $('#voteModalVoteOptionImage').attr('src', image);
    $('#voteModal').modal({
        show: true,
        close: false
    });
}

function backToTop() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
}
function back() {
    window.history.back();
}
